import React from 'react';
import { useEffect, useState } from 'react';
import { randomID } from '../../helper_functions/helper_functions';

const AddOrder = ({ handleCurrentOrders, orderToUpdate, handleUpdateOrder, clientInfo, updateClientInfo }) => {
  const [text, setText] = useState('');
  const [client, setClient] = useState('');
  const [phone, setPhone] = useState('');

  useEffect(() => {
    if (orderToUpdate) {
      setPhone(orderToUpdate.value.phone)
      setText(orderToUpdate.value.text)
      let newCI  = clientInfo.filter((c) => Number(c.number) === Number(orderToUpdate.value.phone))
      setClient(newCI[0])
    }
  }, [clientInfo, orderToUpdate])

  const addNewOrder = (e) => {
    e.preventDefault();

    const date = new Date();

    const newOrder = !orderToUpdate ? 
      {
        id: randomID(),
        value: {
          text,
          phone
        },
        state: 'pending',
        time: date.getHours() + ' : ' + date.getMinutes(),
        price: 5,
        date: date
      } 
      : Object.assign({}, orderToUpdate, {value: {text, phone}})
    
    if (client.id) {
      let newCI  = [...clientInfo].map((c) => {
        if (c.id === client.id) {
          c.info = client.info
        }
        return c
      });
      updateClientInfo(newCI)
    }else {
      let newCI  = [...clientInfo]
      newCI.push({number: phone, info: client.info, id: randomID()})
      updateClientInfo(newCI)
    }

    if (orderToUpdate) {
      handleCurrentOrders(newOrder, 'update');
      handleUpdateOrder('');
    }else {
      handleCurrentOrders(newOrder, 'add');   
    }

    setText('');
    setPhone('');
    setClient('')
  }

  const closeUpdateOrder = (e) => {
    e.preventDefault();
    handleUpdateOrder('');
    setText('');
    setPhone('');
    setClient('')
  }

  const handleClientInfo = (x) => {
    setPhone(x);
    if (/01[0-9]{9}$/.test(x)) {
      let newCI  = [...clientInfo].filter((c) => Number(c.number) === Number(x));
      
      if (newCI.length) {
        setClient(newCI[0])
      }else {
        setClient({number: '', info: ''})
      }
    }else {
      setClient('')
    }
  }

  const handleC = (e) => {
    let newClient = {...client}
    newClient.info = e.target.value
    setClient(newClient)
  }

  return (
    <form className='operations-inputs' onSubmit={addNewOrder}>
      <textarea 
        style={{
          visibility: `${client ? 'visible': 'hidden'}`
        }}
        placeholder='enter client data'
        name='text'
        value={client.info}
        onChange={(e) => handleC(e)}
        required
      ></textarea>
      <input 
        type='tel' 
        placeholder='0123 456 7890' 
        pattern='0[0-9]{10}' 
        name="phone" 
        onChange={(e) => handleClientInfo(e.target.value)}
        value={phone}
        required
      />
      <textarea 
        placeholder='enter order'
        name='text'
        onChange={(e) => setText(e.target.value)}
        value={text}
        required
      ></textarea>
      <div className='buttons'>
        <button>+</button>
        {orderToUpdate &&
        <button 
          className='remove' 
          type='button'
          onClick={closeUpdateOrder}
        >×</button>}
      </div>
    </form>
  )
}

export default AddOrder;